import React from 'react';

import CheckboxInput from 'ui-library/inputs/CheckboxInput';
import {InputChangeEvent} from 'util/Types';

export default function TrialSubjectCheckbox(props: {
  disabled: boolean;
  onChange: (isChecked: boolean) => void;
  isChecked: boolean;
}): JSX.Element {
  return (
    <div>
      <CheckboxInput
        id="trial-subject-checkbox"
        label="Configure as a trial subject"
        checked={props.isChecked}
        onChange={(e: InputChangeEvent) => {
          props.onChange(e.target.checked);
        }}
        disabled={props.disabled}
        className="u-tiny-spacing-bottom"
      />
    </div>
  );
}
